/**
 * Add a new client
 *
 * @param client
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as contactActions from "../graphql/actions/clientRate";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";

export function add(rate) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(rate));
        contactActions.add(
            function (response) {
                dispatch(saved(response.data.createClientRate));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedClientRate(response.data.createClientRate));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            rate
        );
    };
}


export function edit(rate) {
    let id = rate.id;
    delete rate.id;
    delete rate.__typename;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(rate));
        contactActions.edit(
            function (response) {
                dispatch(saved(response.data.editClientRate));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            rate
        );
    };
}

export function fetchRates(clientId, force = false) {
    return dispatch => {
        dispatch(loading());
        contactActions.getRates(
            function (response) {
                dispatch(receiveRates(response.data.clientRates));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            clientId,
            force
        );
    };
}

export function deleteClientrate(clientrateID) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/clientrate/delete/"+clientrateID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingClientrate());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(notify({message: l10n.messages.removed, status: 'success'}));
                return response;
            })
            .then((response) => {
                dispatch(doneDeletingClientrate());
                response.json().then(function(data) {
                    dispatch(fetchRates(data.client,true));
                });
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingClientrate());
            });
    };
}

export function deletingClientrate () {
    return {
        type: types.DELETING_CLIENT_RATE
    };
}

export function doneDeletingClientrate (){
    return {
        type: types.DONE_DELETING_CLIENT_RATE
    };
}

export function loading() {
    return {
        type: types.LOADING_CLIENT_RATE
    };
}

export function saving(contact) {
    return {
        type: types.SAVING_CLIENT_RATE,
        payload: contact
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_CLIENT_RATES,
    };
}

export function saved(contact) {
    return {
        type: types.SAVED_CLIENT_RATE,
        payload: contact
    };
}

export function receiveRates(data) {
    return {
        type: types.RECEIVED_CLIENT_RATES,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/clientRate.js